import React, { useState } from "react";
import { FaPlus, FaTrash, FaImage, FaEdit } from "react-icons/fa";

const ContentManager = ({ section, onContentAdd, onContentRemove }) => {
  const [showModal, setShowModal] = useState(false);
  const [newContent, setNewContent] = useState({
    type: "",
    // Product fields
    name: "",
    description: "",
    image: null,
    imagePreview: null,
    // OtherChoice fields
    order: "",
    label: "",
    // Input fields
    placeholder: "",
    suffix: ""
  });

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNewContent({
        ...newContent,
        image: file,
        imagePreview: URL.createObjectURL(file)
      });
    }
  };

  const handleCreateContent = () => {
    // Validation selon le type
    if (!newContent.type) {
      alert("Veuillez sélectionner un type de contenu");
      return;
    }

    let isValid = false;
    let contentToAdd = {};

    switch (newContent.type) {
      case "products":
        if (!newContent.name || !newContent.description) {
          alert("Veuillez remplir le nom et la description du produit");
          return;
        }
        isValid = true;
        contentToAdd = {
          id: Date.now(),
          type: "products",
          name: newContent.name,
          description: newContent.description,
          image: newContent.imagePreview || newContent.image,
          selected: false
        };
        break;

      case "other_choice":
        if (!newContent.order || !newContent.label) {
          alert("Veuillez remplir l'ordre et le label du choix");
          return;
        }
        isValid = true;
        contentToAdd = {
          id: Date.now(),
          type: "other_choice",
          order: parseInt(newContent.order),
          label: newContent.label,
          selected: false
        };
        break;

      case "input":
        if (!newContent.order || !newContent.label) {
          alert("Veuillez remplir l'ordre et le label de la saisie");
          return;
        }
        isValid = true;
        contentToAdd = {
          id: Date.now(),
          type: "input",
          order: parseInt(newContent.order),
          label: newContent.label,
          placeholder: newContent.placeholder,
          suffix: newContent.suffix,
          selected: false
        };
        break;

      case "text":
        if (!newContent.name || !newContent.description) {
          alert("Veuillez remplir le titre et la description du texte");
          return;
        }
        isValid = true;
        contentToAdd = {
          id: Date.now(),
          type: "text",
          name: newContent.name,
          description: newContent.description,
          selected: false
        };
        break;

      default:
        alert("Type de contenu non reconnu");
        return;
    }

    if (isValid) {
      onContentAdd(section.id, contentToAdd);

      // Réinitialiser le formulaire
      setNewContent({
        type: "",
        name: "",
        description: "",
        image: null,
        imagePreview: null,
        order: "",
        label: "",
        placeholder: "",
        suffix: ""
      });
      setShowModal(false);
    }
  };

  const renderContentPreview = () => {
    switch (newContent.type) {
      case "products":
        return (
          <div className="text-center">
            <div className="materiau-wrapper">
              {newContent.imagePreview ? (
                <img
                  src={newContent.imagePreview}
                  alt="Aperçu"
                  style={{ maxWidth: "100px", height: "auto" }}
                />
              ) : (
                <div className="bg-secondary text-white d-flex align-items-center justify-content-center"
                     style={{ width: "100px", height: "100px" }}>
                  <FaImage size={30} />
                </div>
              )}
              <div className="rectangle px-4 py-1 mt-2">
                <p className="Card-title">{newContent.name || "Nom du produit"}</p>
                {newContent.description && (
                  <p className="Card-sub-title">{newContent.description}</p>
                )}
              </div>
            </div>
          </div>
        );

      case "other_choice":
        return (
          <div className="other-choice-box p-3 border rounded">
            <p className="text-center fw-bold">
              {newContent.label || "Label du choix"}
            </p>
            <small className="text-muted">
              Ordre: {newContent.order || "Non défini"}
            </small>
          </div>
        );

      case "input":
        return (
          <div className="d-flex flex-column">
            <label className="label-be">
              {newContent.label || "Label de la saisie"}
            </label>
            <div className="input-wrapper">
              <input 
                type="text" 
                placeholder={newContent.placeholder || "Placeholder"}
                disabled
              />
              {newContent.suffix && <span className="unit">{newContent.suffix}</span>}
            </div>
            <small className="text-muted">
              Ordre: {newContent.order || "Non défini"}
            </small>
          </div>
        );

      case "text":
        return (
          <div className="text-content p-3 border rounded">
            <h6>{newContent.name || "Titre du texte"}</h6>
            <p>{newContent.description || "Description du texte"}</p>
          </div>
        );

      default:
        return <p className="text-muted">Sélectionnez un type pour voir l'aperçu</p>;
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={() => setShowModal(true)}
      >
        <FaPlus /> Ajouter du contenu
      </button>

      {/* Modal pour ajouter du contenu */}
      {showModal && (
        <div className="modal fade show" style={{ display: "block", zIndex: 1050 }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Ajouter du contenu à "{section.title}"</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Type de contenu *</label>
                      <select
                        className="form-control"
                        value={newContent.type}
                        onChange={(e) => setNewContent({...newContent, type: e.target.value})}
                      >
                        <option value="">Sélectionner un type</option>
                        <option value="products">Produits</option>
                        <option value="text">Texte</option>
                        <option value="other_choice">Autre choix</option>
                        <option value="input">Saisie</option>
                      </select>
                    </div>

                    {/* Champs pour Product et Text */}
                    {(newContent.type === "products" || newContent.type === "text") && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">
                            {newContent.type === "products" ? "Nom du produit *" : "Titre du texte *"}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={newContent.name}
                            onChange={(e) => setNewContent({...newContent, name: e.target.value})}
                            placeholder={newContent.type === "products" ? "Nom du produit" : "Titre du texte"}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Description *</label>
                          <textarea
                            className="form-control"
                            value={newContent.description}
                            onChange={(e) => setNewContent({...newContent, description: e.target.value})}
                            placeholder="Description"
                            rows="3"
                          />
                        </div>
                      </>
                    )}

                    {/* Champs pour OtherChoice et Input */}
                    {(newContent.type === "other_choice" || newContent.type === "input") && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">Ordre *</label>
                          <input
                            type="number"
                            className="form-control"
                            value={newContent.order}
                            onChange={(e) => setNewContent({...newContent, order: e.target.value})}
                            placeholder="Ordre"
                            min="1"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Label *</label>
                          <input
                            type="text"
                            className="form-control"
                            value={newContent.label}
                            onChange={(e) => setNewContent({...newContent, label: e.target.value})}
                            placeholder="Label"
                          />
                        </div>
                      </>
                    )}

                    {/* Champs spécifiques pour Input */}
                    {newContent.type === "input" && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">Placeholder</label>
                          <input
                            type="text"
                            className="form-control"
                            value={newContent.placeholder}
                            onChange={(e) => setNewContent({...newContent, placeholder: e.target.value})}
                            placeholder="Placeholder"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Suffix</label>
                          <input
                            type="text"
                            className="form-control"
                            value={newContent.suffix}
                            onChange={(e) => setNewContent({...newContent, suffix: e.target.value})}
                            placeholder="Suffix (ex: mm, m²)"
                          />
                        </div>
                      </>
                    )}

                    {/* Champs spécifiques pour Product */}
                    {newContent.type === "products" && (
                      <div className="mb-3">
                        <label className="form-label">
                          <FaImage className="me-2" />
                          Image du produit
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={handleImageChange}
                        />
                        <small className="text-muted">
                          Formats acceptés: JPG, PNG, GIF (max 5MB)
                        </small>
                        
                        {newContent.imagePreview && (
                          <div className="mt-3 text-center">
                            <img 
                              src={newContent.imagePreview} 
                              alt="Aperçu" 
                              className="img-fluid rounded"
                              style={{ maxHeight: '150px', maxWidth: '200px' }}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="col-md-6">
                    <div className="mt-4">
                      <h6>Aperçu du contenu :</h6>
                      <div className="border rounded p-3 bg-light">
                        {renderContentPreview()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Annuler
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleCreateContent}
                >
                  Ajouter
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Overlay pour le modal */}
      {showModal && (
        <div 
          className="modal-backdrop fade show"
          onClick={() => setShowModal(false)}
          style={{ zIndex: 1040 }}
        ></div>
      )}
    </>
  );
};

export default ContentManager; 